import React, { useState } from "react";
import { Modal, Input } from "antd";
import { REJECTION_REMARKS_MAX_LENGTH } from "../../utils/agreementMapping";
import styles from "./agreementTracking.module.scss";

const RejectionModal = ({ open, onCancel, onSubmit }) => {
  const [remarks, setRemarks] = useState("");
  const [showError, setShowError] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const reset = () => {
    setRemarks("");
    setShowError(false);
    setSubmitting(false);
  };

  const handleCancel = () => {
    reset();
    onCancel();
  };

  const handleSubmit = async () => {
    if (!remarks.trim()) {
      setShowError(true);
      return;
    }
    setSubmitting(true);
    const submitted = await onSubmit(remarks.trim());
    if (submitted) {
      reset();
    } else {
      setSubmitting(false);
    }
  };

  return (
    <Modal
      open={open}
      centered
      width={424}
      footer={null}
      onCancel={handleCancel}
      destroyOnClose
      title={<span className={styles.modalTitle}>Reason for rejection</span>}
    >
      <div className={styles.rejection}>
        <Input.TextArea
          rows={4}
          value={remarks}
          maxLength={REJECTION_REMARKS_MAX_LENGTH}
          placeholder="Enter your reason for rejection"
          onChange={(e) => {
            setRemarks(e.target.value);
            if (e.target.value.trim()) setShowError(false);
          }}
        />
        {showError ? (
          <p className={styles.error}>
            *Sharing remarks is mandatory when you reject
          </p>
        ) : null}
        <div className={styles.footer}>
          <button onClick={handleCancel}>Cancel</button>
          <button onClick={handleSubmit} disabled={submitting}>
            Submit
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RejectionModal;
